<div class="finish-account-root">
  <div class="account-migration-root" *transloco="let t">
    <app-epson-logo></app-epson-logo>
    <app-label isBig>{{t('now-lets-finish-creating-your-account')}}</app-label>
    <app-paragraph>{{t('finish-creating-account-info')}}</app-paragraph>
    <app-primary-button (clickAction)="finishCreatingAccount()">{{t('finish-creating-your-account')}}
    </app-primary-button>
    <app-epson-powered></app-epson-powered>
  </div>
</div>
